import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import QRCode from "qrcode";

import receiptRecords700 from "../data/listado_700_blockchain_fecha_corregida_22oct2025.json";
import receiptRecords600 from "../data/listado_600_blockchain_fecha_corregida_28oct2025.json";
import receiptRecords550 from "../data/listado_550_blockchain_fecha_corregida_29oct2025.json";

import cyberRecords700 from "../data/bloque_1_700.json";
import cyberRecords1220 from "../data/bloque_2_1220.json";
import cyberRecords1080 from "../data/bloque_3_1080.json";

import styles from "./IdentificationReceiptPage.module.css";

const INNOVATIVE_LOGO =
  "https://Images-logos.b-cdn.net/Empresa/1%20LOGOBLUE_FONDOTRANSPARENTE%20(1).png";

const COACH_LOGO =
  "https://Images-logos.b-cdn.net/Empresa/IMAGOTIPO%20OCREO%20SOMBRA.png";

const withCourse = (records, courseKey) =>
  Array.isArray(records)
    ? records.map((item) => ({
        ...item,
        __courseKey: courseKey,
      }))
    : [];

const ALL_RECEIPT_RECORDS = [
  ...withCourse(receiptRecords700, "blockchain"),
  ...withCourse(receiptRecords600, "blockchain"),
  ...withCourse(receiptRecords550, "blockchain"),

  ...withCourse(cyberRecords700, "ciberseguridad"),
  ...withCourse(cyberRecords1220, "ciberseguridad"),
  ...withCourse(cyberRecords1080, "ciberseguridad"),
];

const COURSE_CONFIGS = {
  blockchain: {
    pageTitle: "Identificación académica | Coach Blockchain",
    brandTop: "COACH",
    brandBottom: "BLOCKCHAIN",
    partnerText: "Programa educativo especializado en tecnología Blockchain",
    introText:
      "Se expide la presente identificación académica digital como constancia de adquisición del servicio educativo correspondiente al curso:",
    serviceTitle: "DOMINANDO BLOCKCHAIN",
    issuedBy: [
      "Coach Blockchain",
      "En vinculación académica con la Universidad Virtual del Estado de Guanajuato (UVEG)",
    ],
    uvegInfo:
      "La UVEG es una institución educativa pública del Estado de Guanajuato orientada a la formación académica en entornos virtuales, con enfoque en accesibilidad, innovación educativa, desarrollo profesional y fortalecimiento de competencias para la vida laboral y tecnológica.",
    duration: [
      "Programa intensivo de formación académica",
      "Modalidad teórico-práctica",
      "Seguimiento por contenidos, sesiones y materiales digitales",
    ],
    platforms: [
      "Sesiones en línea",
      "Materiales de apoyo digitales",
      "Recursos audiovisuales",
      "Acompañamiento formativo",
      "Actividades prácticas guiadas",
    ],
    objective:
      "Que las y los participantes comprendan de manera clara, estructurada y aplicada los fundamentos del ecosistema Blockchain, las diferencias entre redes públicas y privadas, el funcionamiento y clasificación de los tokens, los procesos de tokenización de activos, el uso de wallets, la seguridad en transacciones digitales y los principios esenciales de las finanzas descentralizadas.",
    profile:
      "Curso dirigido a estudiantes, profesionistas, emprendedores y personas interesadas en comprender el funcionamiento de Blockchain, sus aplicaciones reales, la economía digital basada en tokens y las nuevas oportunidades tecnológicas del ecosistema descentralizado.",
    learningOutcomes: [
      "Comprender qué es Blockchain y cómo funciona su estructura básica",
      "Distinguir tipos de redes Blockchain y sus principales usos",
      "Identificar la lógica económica y funcional de los tokens",
      "Reconocer las diferencias entre utility tokens, governance tokens, stablecoins y NFTs",
      "Entender el proceso de tokenización de activos del mundo real y digital",
      "Aplicar buenas prácticas básicas de seguridad en entornos Web3",
      "Comprender fundamentos de DeFi, wallets, exchanges y transacciones",
      "Relacionar Blockchain con casos de uso reales en educación, finanzas, identidad y activos digitales",
    ],
    thematicContent: [
      "Fundamentos de Blockchain",
      "Tipos de redes Blockchain",
      "Economía de los Tokens",
      "Tipos de Tokens",
      "Tokenización de Activos",
      "Seguridad en Blockchain",
      "DeFi y finanzas descentralizadas",
      "Wallets y transacciones",
      "NFTs: creación y comercio",
      "Trading y exchanges",
      "Cumplimiento regulatorio",
      "Marketing y construcción de comunidad",
      "Tecnologías emergentes en Blockchain",
      "Cierre y proyecto final",
    ],
    materials: [
      "Material de lectura digital",
      "Presentaciones y recursos visuales",
      "Ejemplos explicativos del ecosistema Blockchain",
      "Guías introductorias sobre tokens, wallets y DeFi",
      "Recursos de consulta para profundización autónoma",
    ],
    methodology: [
      "Exposición guiada de conceptos",
      "Explicación progresiva de fundamentos técnicos",
      "Aprendizaje orientado a comprensión práctica",
      "Uso de ejemplos del entorno real Web3",
      "Acompañamiento con materiales digitales complementarios",
    ],
    instructorBase: "Sandra Marquez Figueroa",
    facilitators: ["Staff de la UVEG"],
    curriculumHours: "114 horas",
    processCertification: "Smart Quality Institute",
    subtotal: "$1,890.80 MXN",
    taxes: "$0 MXN",
    total: "$1,890.80 MXN",
    discountNote: "Con cupón de descuento aplicado",
    companyInfo: {
      name: "INNOVATIVE HORIZONS LLC",
      taxId: "301433627",
      address: "Lincoln RD STE 708, Miami Beach, Florida",
      cityZip: "33139",
      country: "Estados Unidos",
    },
    paymentConcept:
      'Apoyo Educativo UVEG para el Desarrollo de Habilidades Digitales a través de la Certificación "DOMINANDO BLOCKCHAIN".',
    paymentMethod: "Transferencia",
    status: "Pagado",
    issueDate: "29 de octubre del 2025",
    addressLine1: "Coach Blockchain",
    addressLine2: "Identificación académica digital de servicio educativo",
  },

  ciberseguridad: {
    pageTitle: "Identificación académica | Diplomado en Ciberseguridad",
    brandTop: "COACH",
    brandBottom: "BLOCKCHAIN",
    partnerText: "Programa educativo especializado en Ciberseguridad",
    introText:
      "Se expide la presente identificación académica digital como constancia de adquisición del servicio educativo correspondiente al diplomado:",
    serviceTitle: "DIPLOMADO EN CIBERSEGURIDAD",
    issuedBy: [
      "Coach Blockchain",
      "En vinculación académica con la Universidad Virtual del Estado de Guanajuato (UVEG)",
    ],
    uvegInfo:
      "La UVEG es una institución educativa pública del Estado de Guanajuato orientada a la formación académica en entornos virtuales, con enfoque en accesibilidad, innovación educativa, desarrollo profesional y fortalecimiento de competencias para la vida laboral y tecnológica.",
    duration: [
      "Diplomado de formación académica",
      "Modalidad virtual",
      "Seguimiento por módulos, actividades, materiales digitales y recursos audiovisuales",
    ],
    platforms: [
      "Plataforma educativa",
      "Materiales de apoyo digitales",
      "Recursos audiovisuales",
      "Actividades prácticas guiadas",
      "Evaluaciones formativas",
      "Acompañamiento académico",
    ],
    objective:
      "Que las y los participantes comprendan los fundamentos de la ciberseguridad, las principales amenazas digitales, los riesgos asociados al uso de sistemas informáticos, la protección de datos, la seguridad en redes, las buenas prácticas de prevención, la identificación de incidentes y la aplicación de medidas básicas para proteger información, dispositivos, usuarios y organizaciones.",
    profile:
      "Diplomado dirigido a estudiantes, profesionistas, emprendedores, personal administrativo, docentes y personas interesadas en fortalecer sus conocimientos sobre seguridad digital, protección de información, prevención de riesgos tecnológicos y buenas prácticas de ciberseguridad.",
    learningOutcomes: [
      "Comprender los conceptos fundamentales de la ciberseguridad",
      "Identificar amenazas, vulnerabilidades y riesgos digitales",
      "Reconocer ataques comunes como phishing, malware, ransomware e ingeniería social",
      "Aplicar buenas prácticas de seguridad en el uso de dispositivos y cuentas digitales",
      "Comprender principios básicos de protección de datos personales",
      "Identificar medidas de seguridad en redes, sistemas operativos y plataformas digitales",
      "Reconocer la importancia de la respuesta ante incidentes",
      "Relacionar la ciberseguridad con el entorno laboral, educativo y organizacional",
    ],
    thematicContent: [
      "Fundamentos de ciberseguridad",
      "Amenazas digitales",
      "Malware y ransomware",
      "Phishing e ingeniería social",
      "Seguridad de contraseñas",
      "Autenticación y control de acceso",
      "Protección de datos personales",
      "Seguridad en redes",
      "Seguridad del sistema operativo",
      "Hardening básico",
      "Buenas prácticas de navegación segura",
      "Gestión de incidentes",
      "Marco legal de la ciberseguridad",
      "Ética y responsabilidad digital",
    ],
    materials: [
      "Material de lectura digital",
      "Presentaciones y recursos visuales",
      "Ejemplos explicativos de amenazas reales",
      "Guías introductorias de protección digital",
      "Recursos de consulta para profundización autónoma",
    ],
    methodology: [
      "Exposición guiada de conceptos",
      "Explicación progresiva de fundamentos técnicos",
      "Aprendizaje orientado a la prevención de riesgos",
      "Uso de ejemplos del entorno digital real",
      "Acompañamiento con materiales digitales complementarios",
    ],
    instructorBase: "Sandra Marquez Figueroa",
    facilitators: ["Staff de la UVEG"],
    curriculumHours: "120 horas",
    processCertification: "Smart Quality Institute",
    subtotal: "$1,890.80 MXN",
    taxes: "$0 MXN",
    total: "$1,890.80 MXN",
    discountNote: "Con cupón de descuento aplicado",
    companyInfo: {
      name: "INNOVATIVE HORIZONS LLC",
      taxId: "301433627",
      address: "Lincoln RD STE 708, Miami Beach, Florida",
      cityZip: "33139",
      country: "Estados Unidos",
    },
    paymentConcept:
      'Apoyo Educativo UVEG para el Desarrollo de Habilidades Digitales a través del "DIPLOMADO EN CIBERSEGURIDAD".',
    paymentMethod: "Transferencia",
    status: "Pagado",
    issueDate: "29 de octubre del 2025",
    addressLine1: "Coach Blockchain",
    addressLine2: "Identificación académica digital de servicio educativo",
  },
};

function ensureRobotsMeta() {
  const existing = document.querySelector('meta[name="robots"]');

  if (existing) {
    existing.setAttribute("content", "noindex, nofollow, noarchive");
    return;
  }

  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow, noarchive";
  document.head.appendChild(meta);
}

function normalizeToken(input = "") {
  return decodeURIComponent(input).trim();
}

function getField(obj, keys = [], fallback = "") {
  for (const key of keys) {
    if (
      obj?.[key] !== undefined &&
      obj?.[key] !== null &&
      String(obj[key]).trim() !== ""
    ) {
      return obj[key];
    }
  }

  return fallback;
}

function buildReceiptMap(records) {
  return records.reduce((acc, item) => {
    const rawToken = getField(item, ["Token", "token"], "");

    if (rawToken) {
      acc[String(rawToken).trim()] = item;
    }

    return acc;
  }, {});
}

function LabelBlock({ title, items, longText }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>{title}</h3>

      {Array.isArray(items) && items.length > 0 && (
        <ul className={styles.list}>
          {items.map((item, index) => (
            <li key={`${title}-${index}`}>{item}</li>
          ))}
        </ul>
      )}

      {longText && <p className={styles.paragraph}>{longText}</p>}
    </section>
  );
}

function PaymentSummary({ COURSE_CONFIG }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>DETALLE DE PAGO</h3>

      <div className={styles.paymentBox}>
        <div className={styles.paymentRow}>
          <span>Subtotal</span>
          <strong>{COURSE_CONFIG.subtotal}</strong>
        </div>

        <div className={styles.paymentRow}>
          <span>Impuestos</span>
          <strong>{COURSE_CONFIG.taxes}</strong>
        </div>

        <div className={`${styles.paymentRow} ${styles.paymentTotal}`}>
          <span>Pago total</span>
          <strong>{COURSE_CONFIG.total}</strong>
        </div>

        <div className={styles.paymentNote}>{COURSE_CONFIG.discountNote}</div>
      </div>
    </section>
  );
}

function CompanyDataBlock({ COURSE_CONFIG }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>DATOS DE LA EMPRESA</h3>

      <div className={styles.infoGrid}>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Nombre:</span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.companyInfo.name}
          </span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>
            Número de Identificación Fiscal:
          </span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.companyInfo.taxId}
          </span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Domicilio:</span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.companyInfo.address}
          </span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>C.P.:</span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.companyInfo.cityZip}
          </span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>País:</span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.companyInfo.country}
          </span>
        </div>
      </div>
    </section>
  );
}

function RecipientDataBlock({
  COURSE_CONFIG,
  nombreCompleto,
  curp,
  folio,
  matricula,
  issueDate,
}) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>RECIBO EXPEDIDO A</h3>

      <div className={styles.infoGrid}>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Nombre completo:</span>
          <span className={styles.infoValue}>{nombreCompleto}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>CURP:</span>
          <span className={styles.infoValue}>{curp}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Matrícula:</span>
          <span className={styles.infoValue}>{matricula}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Folio educativo:</span>
          <span className={styles.infoValue}>{folio}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Forma de pago:</span>
          <span className={styles.infoValue}>
            {COURSE_CONFIG.paymentMethod}
          </span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Estatus:</span>
          <span className={styles.infoValue}>{COURSE_CONFIG.status}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Fecha de expedición:</span>
          <span className={styles.infoValue}>{issueDate}</span>
        </div>
      </div>
    </section>
  );
}

function ConceptBlock({ COURSE_CONFIG }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>CONCEPTO DE PAGO</h3>
      <p className={styles.paragraph}>{COURSE_CONFIG.paymentConcept}</p>
    </section>
  );
}

export default function IdentificationReceiptPage() {
  const { token } = useParams();
  const [qrDataUrl, setQrDataUrl] = useState("");

  const receiptMap = useMemo(() => buildReceiptMap(ALL_RECEIPT_RECORDS), []);
  const receipt = receiptMap[normalizeToken(token)];

  const courseKey = receipt?.__courseKey || "blockchain";
  const COURSE_CONFIG =
    COURSE_CONFIGS[courseKey] || COURSE_CONFIGS.blockchain;

  useEffect(() => {
    document.title = COURSE_CONFIG.pageTitle;
    ensureRobotsMeta();
    window.scrollTo(0, 0);
  }, [COURSE_CONFIG.pageTitle]);

  const currentUrl =
    typeof window !== "undefined" ? window.location.href : "";

  const folio = getField(
    receipt,
    ["Folio educativo", "folio", "Folio"],
    "FOLIO-NO-DISPONIBLE"
  );

  const nombreCompleto = getField(
    receipt,
    ["Nombre completo", "nombre_completo", "nombreCompleto", "nombre"],
    "Sin nombre"
  );

  const curp = getField(receipt, ["CURP", "curp"], "Sin CURP");

  const visibleToken = getField(receipt, ["Token", "token"], "");

  const matricula = getField(
    receipt,
    ["Matrícula", "Matricula", "matricula", "MATRICULA"],
    "No disponible"
  );

  const issueDate = getField(
    receipt,
    ["fecha_pago", "Fecha de pago", "issueDate", "fecha"],
    COURSE_CONFIG.issueDate
  );

  useEffect(() => {
    if (!receipt || !currentUrl) return;

    const payload = [
      `Curso: ${COURSE_CONFIG.serviceTitle}`,
      `Folio: ${folio}`,
      `Nombre: ${nombreCompleto}`,
      `CURP: ${curp}`,
      `Matrícula: ${matricula}`,
      `Token: ${visibleToken}`,
      `URL: ${currentUrl}`,
    ].join("\n");

    QRCode.toDataURL(payload, {
      width: 300,
      margin: 1,
      errorCorrectionLevel: "M",
      color: {
        dark: "#133B6C",
        light: "#FFFFFF",
      },
    })
      .then((url) => setQrDataUrl(url))
      .catch(() => setQrDataUrl(""));
  }, [
    receipt,
    currentUrl,
    folio,
    nombreCompleto,
    curp,
    matricula,
    visibleToken,
    COURSE_CONFIG.serviceTitle,
  ]);

  if (!receipt) {
    return (
      <main className={styles.pageWrap}>
        <div className={styles.notFoundCard}>
          <img
            src={COACH_LOGO}
            alt="Coach Blockchain"
            className={styles.notFoundLogo}
          />

          <h1>Recibo no encontrado</h1>

          <p>
            El enlace no existe, fue revocado o el token no corresponde a ningún
            estudiante registrado.
          </p>

          <p style={{ marginTop: "12px", fontSize: "14px", opacity: 0.8 }}>
            Se buscaron registros en los lotes de Blockchain y Ciberseguridad.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className={styles.pageWrap}>
      <article className={styles.receiptShell}>
        <header className={styles.heroHeader}>
          <div className={styles.headerTopRow}>
            <img
              src={INNOVATIVE_LOGO}
              alt="Innovative Horizons LLC"
              className={styles.headerLogoLeft}
            />

            <div className={styles.brandCenterBlock}>
              <div className={styles.brandTop}>{COURSE_CONFIG.brandTop}</div>
              <div className={styles.brandBottom}>
                {COURSE_CONFIG.brandBottom}
              </div>
              <div className={styles.partnerText}>
                {COURSE_CONFIG.partnerText}
              </div>
            </div>

            <img
              src={COACH_LOGO}
              alt="Coach Blockchain"
              className={styles.headerLogoRight}
            />
          </div>
        </header>

        <div className={styles.goldBar} />

        <section className={styles.card} id="receipt-print-area">
          <p className={styles.intro}>{COURSE_CONFIG.introText}</p>

          <div className={styles.courseHero}>
            <div className={styles.courseTitle}>
              {COURSE_CONFIG.serviceTitle}
            </div>
          </div>

          <CompanyDataBlock COURSE_CONFIG={COURSE_CONFIG} />

          <RecipientDataBlock
            COURSE_CONFIG={COURSE_CONFIG}
            nombreCompleto={nombreCompleto}
            curp={curp}
            folio={folio}
            matricula={matricula}
            issueDate={issueDate}
          />

          <ConceptBlock COURSE_CONFIG={COURSE_CONFIG} />

          <LabelBlock title="IMPARTE" items={COURSE_CONFIG.issuedBy} />

          <LabelBlock
            title="INFORMACIÓN INSTITUCIONAL UVEG"
            longText={COURSE_CONFIG.uvegInfo}
          />

          <LabelBlock
            title="DURACIÓN Y MODALIDAD"
            items={COURSE_CONFIG.duration}
          />

          <LabelBlock
            title="PLATAFORMAS Y RECURSOS"
            items={COURSE_CONFIG.platforms}
          />

          <LabelBlock
            title="OBJETIVO GENERAL"
            longText={COURSE_CONFIG.objective}
          />

          <LabelBlock
            title="PERFIL DE INGRESO / DIRIGIDO A"
            longText={COURSE_CONFIG.profile}
          />

          <LabelBlock
            title="RESULTADOS DE APRENDIZAJE"
            items={COURSE_CONFIG.learningOutcomes}
          />

          <LabelBlock
            title="CONTENIDO TEMÁTICO"
            items={COURSE_CONFIG.thematicContent}
          />

          <LabelBlock
            title="MATERIALES DEL CURSO"
            items={COURSE_CONFIG.materials}
          />

          <LabelBlock
            title="METODOLOGÍA"
            items={COURSE_CONFIG.methodology}
          />

          <LabelBlock
            title="PROFESOR"
            items={[COURSE_CONFIG.instructorBase]}
          />

          <LabelBlock
            title="FACILITADORES"
            items={COURSE_CONFIG.facilitators}
          />

          <LabelBlock
            title="HORAS CURRICULARES"
            items={[COURSE_CONFIG.curriculumHours]}
          />

          <LabelBlock
            title="CERTIFICACIÓN DE PROCESOS"
            items={[COURSE_CONFIG.processCertification]}
          />

          <PaymentSummary COURSE_CONFIG={COURSE_CONFIG} />

          <LabelBlock title="STATUS" items={[COURSE_CONFIG.status]} />

          <LabelBlock title="FECHA DE EXPEDICIÓN" items={[issueDate]} />

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>VALIDACIÓN DIGITAL</h3>

            <div className={styles.validationBox}>
              <div className={styles.qrCenterCol}>
                {qrDataUrl ? (
                  <img
                    src={qrDataUrl}
                    alt="Código QR de validación"
                    className={styles.qrImage}
                  />
                ) : (
                  <div className={styles.qrFallback}>Generando QR...</div>
                )}
              </div>

              <div className={styles.validationText}>
                <p>
                  Este documento cuenta con un identificador digital asociado al
                  registro académico del servicio educativo.
                </p>

                <p>
                  <strong>Curso:</strong>
                  <br />
                  {COURSE_CONFIG.serviceTitle}
                </p>

                <p>
                  <strong>Token de validación:</strong>
                  <br />
                  {visibleToken}
                </p>

                <p>
                  <strong>Matrícula:</strong>
                  <br />
                  {matricula}
                </p>

                <p>
                  <strong>URL actual:</strong>
                  <br />
                  {currentUrl}
                </p>
              </div>
            </div>
          </section>

          <div className={styles.footerSealWrap}>
            <img
              src={COACH_LOGO}
              alt="Coach Blockchain"
              className={styles.footerSeal}
            />
          </div>

          <div className={styles.addressBlock}>
            <p>{COURSE_CONFIG.addressLine1}</p>
            <p>{COURSE_CONFIG.addressLine2}</p>
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.printButton}
              onClick={() => window.print()}
            >
              Descargar / Imprimir PDF
            </button>

            <a href={currentUrl} className={styles.copyableLink}>
              {currentUrl}
            </a>
          </div>
        </section>
      </article>
    </main>
  );
}